<template>
    <div id="Show-News-Panel">
        <kt-row>
            <kt-col lg="8" md="8" xs="8" class="pr-1">
                <h3>{{ query.subject }}</h3>
            </kt-col>
            <kt-col lg="4" md="4" xs="4" class="pl-1">
                <div class="row text-black-50 justify-content-end">
                    <i class="fa fa-clock ml-1" style="margin-top: 1.5px"></i>
                    <span class="pl-1">{{ query.created_at }}</span>
                </div>
            </kt-col>
        </kt-row>
        <hr/>
        <kt-row>
            <kt-col lg="12" md="12" xs="12" v-html="query.newscontent"></kt-col>
        </kt-row>
    </div>
</template>
<script>
export default {
    props: {
        query: {
            default() {
                return {};
            },
            type: Object,
        },
    },
};
</script>